import { render, staticRenderFns } from "./GSideNavigation.vue?vue&type=template&id=0c254d87&scoped=true&"
import script from "./GSideNavigation.vue?vue&type=script&lang=ts&"
export * from "./GSideNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./GSideNavigation.vue?vue&type=style&index=0&id=0c254d87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c254d87",
  null
  
)

export default component.exports